// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"93":"list","180":"story"}[chunkId] || chunkId) + "-" + {"93":"a60ea32d5adb8e9edd1d","180":"295807b7e0a7e34f8ae7","837":"36246cbdbc9d2557929e"}[chunkId] + ".css";
};